import { WarningIcon } from "@chakra-ui/icons";
import { Center, VStack } from "@chakra-ui/layout";
import { Alert, AlertDescription, AlertIcon, Button } from "@chakra-ui/react";
import { useDeleteView } from "features/transactions/hooks/useDeleteView";
import { TransactionsViewTable } from "features/transactions/TransactionsViewTable/TransactionsViewTable";
import { useTableViewGetSuspense } from "gen/endpoints/table-views/table-views";
import { useTranslation } from "react-i18next";
import { QueryBoundary } from "shared/api/QueryBoundary";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";

export const TransactionsViewDetailPageInner: React.FC = () => {
  const { viewId } = useRequiredStringParams();
  const { data } = useTableViewGetSuspense(viewId);

  return <TransactionsViewTable view={data} />;
};

const ErrorComponent = () => {
  const { viewId } = useRequiredStringParams();
  const deleteTransaction = useDeleteView({
    existingViewId: viewId,
  });
  const { t } = useTranslation(["common", "views"]);
  return (
    <Center height="100%">
      <VStack>
        <Alert status="warning" mb="16px">
          <AlertIcon>
            <WarningIcon />
          </AlertIcon>
          <AlertDescription>
            {t("views:errors.viewNotAvailable")}
          </AlertDescription>
        </Alert>
        <Button
          onClick={deleteTransaction.deleteView}
          isLoading={deleteTransaction.isDeleting}
          colorScheme="destructive"
        >
          {t("common:delete")}
        </Button>
      </VStack>
    </Center>
  );
};

export const TransactionsViewDetailPage: React.FC = () => {
  const { viewId } = useRequiredStringParams();
  return (
    <QueryBoundary ErrorComponent={ErrorComponent}>
      <TransactionsViewDetailPageInner key={viewId} />
    </QueryBoundary>
  );
};

export default TransactionsViewDetailPage;
